import { render, staticRenderFns } from "./invite_collaborators_modal.vue?vue&type=template&id=4b878a9e&scoped=true&"
import script from "./invite_collaborators_modal.vue?vue&type=script&lang=js&"
export * from "./invite_collaborators_modal.vue?vue&type=script&lang=js&"
import style0 from "./invite_collaborators_modal.vue?vue&type=style&index=0&id=4b878a9e&prod&lang=scss&"
import style1 from "./invite_collaborators_modal.vue?vue&type=style&index=1&id=4b878a9e&prod&lang=scss&scoped=true&"
import style2 from "./invite_collaborators_modal.vue?vue&type=style&index=2&id=4b878a9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b878a9e",
  null
  
)

export default component.exports